<template>
  <div id="lm-list-2" class="wrapper-content w-100 position-relative">
    <LmComponentLoading v-if="isContentPageLoading" :zIndex="{'z-index': 1008}" />
    <h2>{{titleList}}</h2>
    <LmBreadcrumb v-if="showLmBreadcrumb" />
    <h4
      v-for="(subTitle, index) in subTitlesList"
      :key="index"
    >
      {{ subTitle }}
    </h4>

    <div class="row" v-if="!isOnWidgetMode">
      <div class="col-md-7 mb-3">
        <LmSearcher
          ref="lmSearcher"
          :lmSuperPowerSelectsV2="searcher.lmSuperPowerSelectsV2"
          :searchOnFieldsToSelect="searcher.searchOnFieldsToSelect"
          :searchOnFieldsSelectedProp="searcher.searchOnFieldsSelected"
          :termProp="searcher.term"
          :dateFromProp="searcher.dateFrom"
          :dateUpToProp="searcher.dateUpTo"
          :maxDateUpTo="searcher.maxDateUpTo"
          :showFilterTime="searcher.showFilterTime"
        />
      </div>
      <div class="col-md-5 mt-sm-0 col-12 d-flex justify-content-md-end mb-3" v-if="showFilters && tableItemsTotal">
        <LmFilter
          ref="lmFilter"
          :aggregates="filter.aggregatesToSelect"
          :aggregatesSelectedProp="filter.aggregatesSelected"
          :totalResult="filter.totalResult"
          :loadingProp="isDataProcessing"
          :isGraphql="isGraphql"
        />
      </div>
    </div>
    <div class="position-relative">
      <LmComponentLoading v-if="isDataProcessing" />
      <LmError v-if="tableItemsTotal === 0" />
      <div class="row" v-if="showMap && tableItemsTotal > 0">
        <div class="col-12">
          <LmMap :markers="table.items" :map="map" />
        </div>
      </div>
      <div class="row" v-if="showBox && tableItemsTotal > 0">
        <div class="col-12 m-2 p-0">
          <LmBox :items="table.items" :modeBoxOptions="modeBoxOptions" />
        </div>
      </div>
      <div class="row" v-if="showTable && tableItemsTotal > 0">
        <div class="col-12" v-if="!isTableProcessing">
          <b-table
            v-dragTableHeader="table.fields"
            v-bind="table"
            :striped="tableStriped"
            :responsive="tableResponsive"
            :hover="tableHover"
            :sort-by="orderBy"
            :sort-desc="tableSortDesc"
            no-local-sorting
            @sort-changed="tableSortingChanged"
            :class="{ 'lm-table-while-loading': isDataProcessing, 'lm-oveflow-visible': isOnEditMode }"
            class="btable"
            >
            <template #thead-top="data" v-if="isOnEditMode">
              <b-tr>
                <b-th class="text-center d-none">
                     <b-dropdown text="Mostrar/Ocultar columnas" class="w-50" menu-class="w-100">
                        <div class="p-2 menu-hide-show-columns">
                          <b-form-checkbox
                            v-for="(field, index) in table.allAvailableFields"
                            :key="`checkbox-${field.key}`"
                            :checked="isFieldVisibleOnScreen(field.key)"
                            @input="hideShowColumns($event, field.key, index)"
                          >{{field.label}}</b-form-checkbox>
                        </div>
                    </b-dropdown>
                </b-th>
              </b-tr>
              <b-tr id="dragable-column" :class="{'table-is-on-edit': isOnEditMode}">
                <b-th
                  v-for="(field, index) in data.fields"
                  :key="`fields-${field.key}`"
                  class="border-0"
                  >
                    <b-dropdown variant="outline-secondary m-0 py-1 px-2"  dropup>

                       <div  style="width: 240px;">

                        <div class="px-3 mt-1" >
                          <LmTextInput
                            :id="`fields-${index}`"
                            label="Nombre"
                            v-model="table.fields[index].label" />
                        </div>
                      </div>
                    </b-dropdown>
                    {{ table.fields[index].label }}
                </b-th>
              </b-tr>
            </template>
            <template v-slot:cell()="row">
              <template v-if="row.value.type === 'badge'">
                <b-badge
                  v-for="(tag, index) in row.value.arguments.value.split(',')"
                  :key="index"
                  :variant="variantBuilder(row.value.arguments.variant, index)"
                  pill
                  class="mr-1"
                  >{{ tag }}</b-badge>
              </template>
              <template v-else-if="row.value.type === 'avatar'">
                <b-avatar
                  size="35px"
                  :src="row.value.arguments.avatar"
                  :id="`${row.field.key}_${row.index}`"
                >
                </b-avatar>

                <b-tooltip :target="`${row.field.key}_${row.index}`" triggers="hover" placement="bottom" custom-class="my-2">
                  {{ row.value.arguments.value }} <br>
                  el <b>{{ row.value.arguments.dateTime }}</b>
                </b-tooltip>
              </template>
              <template v-else-if="row.value.type === 'avatarGroup'">
                <b-avatar-group size="35px">
                  <b-avatar
                    v-for="(avatarGroupItem, index) in row.value.arguments"
                    :key="index"
                    badge badge-left
                    :badge-variant="avatarGroupItem.variant"
                    :src="avatarGroupItem.avatar"
                    v-b-tooltip.hover :title="avatarGroupItem.value"
                  >
                    <template #badge><b-icon :icon="avatarGroupItem.icon"></b-icon></template>
                  </b-avatar>
                </b-avatar-group>
              </template>
              <template v-else-if="row.value.type === 'multipleBadges'">
                <b-badge
                  v-for="(badge, index) in row.value.arguments"
                  :key="index"
                  :variant="badge.variant"
                  pill
                  class="mr-1"
                  >{{ badge.value }}</b-badge>
              </template>
              <template v-else-if="row.value.type === 'image'">
                <img
                :src="row.value.arguments.url"
                :alt="row.value.arguments.alt"
                :style="{'max-width': row.value.arguments.maxWidth || '100%'}"
                >
              </template>
              <template v-else-if="row.value.type === 'progress'">
                <b-progress class="mt-1" :max="100">
                  <b-progress-bar :value="row.value.arguments.value" :variant="row.value.arguments.variant" />
                </b-progress>
              </template>
                <template v-else-if="row.value.type === 'internalLink'">
                  <router-link v-if="row.field.key in row.item" :to="row.value.arguments.to">{{row.value.arguments.text}}</router-link>
                </template>
                <template v-else-if="row.value.type === 'externalLink'">
                  <a v-if="row.field.key in row.item" :href="row.value.arguments.href">{{row.value.arguments.text}}</a>
                </template>
              <template v-else-if="row.value.type === 'action'">

                <template v-for="(action, index) in row.value.actions">
                  <router-link
                    :key="index"
                    v-if="action.type === 'path'"
                    :to="action.arguments.to"
                    class="mr-3 text-primary"
                    >
                    <font-awesome-layers>
                      <font-awesome-icon
                        :icon="action.arguments.fontAwesomeIcon || 'edit'"
                        size="lg"
                        class="clickable"
                        v-b-tooltip.hover.top="action.arguments.tooltip"
                        />
                      <font-awesome-layers-text
                        v-if="action.arguments.showDot"
                        class="text-white fa-layers-counter"
                        transform="down-4 right-8 shrink-10"
                        value=""
                        />
                    </font-awesome-layers>
                  </router-link>
                  <font-awesome-icon
                    :key="index"
                    id="open-email-preview-modal"
                    v-if="action.type === 'openEmailPreviewModal'"
                    :icon="action.arguments.fontAwesomeIcon || 'search'"
                    size="lg"
                    class="clickable text-primary mr-2"
                    v-b-tooltip.hover.top="action.arguments.tooltip"
                    @click="openEmailPreviewModal(action.arguments.id)"
                  />
                  <font-awesome-icon
                    :key="index"
                    id="open-delete-modal"
                    v-if="action.type === 'openDeleteModal'"
                    :icon="action.arguments.fontAwesomeIcon || 'trash'"
                    size="lg"
                    class="clickable text-primary mr-2"
                    @click="openDeleteModal(action.arguments.id, action.arguments.endPointPath, action.arguments.message, action.arguments.successMessage)"
                    v-b-tooltip.hover.top="action.arguments.tooltip"
                  />
                  <font-awesome-icon
                    :key="index"
                    id="open-custom-modal"
                    v-if="action.type === 'openCustomModal'"
                    :icon="action.arguments.fontAwesomeIcon || 'window-restore'"
                    size="lg"
                    class="clickable text-primary mr-2"
                    @click="openCustomModal(action.arguments)"
                    v-b-tooltip.hover.top="action.arguments.tooltip"
                  />
                </template>

              </template>
              <template v-else>
                {{row.value}}
              </template>
            </template>
          </b-table>
        </div>
      </div>
      <div class="row" v-if="tableItemsTotal > 0 && !isOnWidgetMode">
        <div v-if="table.items.length" class="showed-items col-md-2 mt-3 col-12 align-self-center">
          <p>
            {{ $route.query.page ? (itemsPerPage * $route.query.page) + 1 - itemsPerPage : 1 }}
            {{$t('to')}}
            {{ getToOfPagination }}
            {{$t('of')}}
            {{tableItemsTotal}} </p>
        </div>
        <div class="col-md-7 mt-sm-3 col-12">
          <b-pagination-nav
            v-bind="pagination"
            :link-gen="linkGen"
            :limit="pagination.limit || 6"
            :value="$route.query.page || 1"
            :number-of-pages="tableItemsTotal ? Math.ceil(tableItemsTotal / itemsPerPage) : 1"
            :hide-ellipsis="paginationHideEllipsis"
            :first-text="paginationFirstText"
            :last-text="paginationLastText"
            :pills="pagination.pills || false"
            use-router
          />
        </div>
      </div>
      <div class="d-flex justify-content-end" v-if="isOnWidgetMode">
        <LmButton
          :value="$t('view_more')"
          type="button"
          buttonClass="btn-primary"
          @click="$router.push(`/listbuilder/view/${listBuilderId}`)"
        />
      </div>
      <div class="row" v-if="Object.keys(buttons).length && !isOnWidgetMode">
        <div class="col-12">
          <LmButton
            v-if="'filterCreator' in buttons && buttons.filterCreator.show"
            type="button"
            lmButtonRootWrapperClass="d-inline-block mr-1"
            lmButtonWrapperClass="col"
            buttonClass="btn-danger"
            :value="$t(buttons.filterCreator.value)"
            :isProcessing="buttons.filterCreator.isProcessing"
            @click.native="createFilterMethod"
          />
          <LmButton
            v-if="'segment' in buttons && buttons.segment.show"
            type="button"
            lmButtonRootWrapperClass="d-inline-block mr-1"
            lmButtonWrapperClass="col"
            buttonClass="btn-danger"
            :value="$t(buttons.segment.value)"
            :isProcessing="buttons.segment.isProcessing"
            @click.native="createSegmentMethod"
          />
          <template v-if="'links' in buttons && buttons.links.length">
            <LmButton
              v-for="(link, index) in buttons.links"
              :key="`index-${index}`"
              type="button"
              :disabled="link.disabled"
              lmButtonRootWrapperClass="d-inline-block mr-1"
              lmButtonWrapperClass="col"
              :buttonClass="link.buttonClass || 'btn-primary'"
              :value="$t(link.value)"
              @click.native="$router.push(link.to)"
            />
          </template>
        </div>
      </div>
    </div>
    <LmTemplatePreviewModal ref="lmTemplatePreviewModal" />
    <LmConfirmationModal ref="lmConfirmationModal" title="Aviso" @ok="confirmModalOk"  />
    <LmCreateSegmentModal
      ref="lmCreateFilterModal"
      v-if="'filterCreator' in buttons"
      :title="buttons.filterCreator.modalTitle"
      :afterCreateSegmentRedirectPath="buttons.filterCreator.afterCreateSegmentRedirectPath"
      :fullFrontEndUrl="buttons.filterCreator.fullFrontEndUrl"
      :apiEndpoint="this.endpointUri.path + this.endpointUri.queryString"
      :pathUrlToSendData="buttons.filterCreator.pathUrlToSendData"
      />
    <LmCreateSegmentModal
      ref="lmCreateSegmentModal"
      v-if="'segment' in buttons"
      :title="buttons.segment.modalTitle"
      :afterCreateSegmentRedirectPath="buttons.segment.afterCreateSegmentRedirectPath"
      :fullFrontEndUrl="buttons.segment.fullFrontEndUrl"
      :apiEndpoint="this.endpointUri.path + this.endpointUri.queryString"
      :pathUrlToSendData="buttons.segment.pathUrlToSendData"
      :hash="buttons.segment.hash"
      />
  </div>
</template>

<script>

import gql from 'graphql-tag'
import _ from 'lodash'
import Sortable from 'sortablejs'

import commonsApi from '@/api/commons'

import LmTemplatePreviewModal from '@/components/modals/LmTemplatePreviewModal.vue'
import LmConfirmationModal from '@/components/modals/LmConfirmationModal.vue'
import LmCreateSegmentModal from '@/components/modals/LmCreateSegmentModal.vue'
import LmSearcher from '@/components/LmSearcher.vue'
import LmFilter from '@/components/LmFilter.vue'
import LmMap from '@/components/LmMap.vue'
import LmBox from '@/components/LmBox.vue'
import LmButton from '@/components/form/elements/LmButton.vue'
import lmToasts from '@/mixins/lmToasts.js'
import LmError from '@/components/LmError.vue'
import LmTextInput from '@/components/form/elements/LmTextInput.vue'

import urlQueryBuilder from '@/mixins/urlQueryBuilder.js'

export default {
  mixins: [urlQueryBuilder, lmToasts],
  components: {
    LmTemplatePreviewModal,
    LmConfirmationModal,
    LmCreateSegmentModal,
    LmSearcher,
    LmFilter,
    LmMap,
    LmBox,
    LmButton,
    LmError,
    LmTextInput
  },
  data () {
    return {
      page: 1,
      decretos: [],
      endpointUri: {
        path: '',
        queryString: '',
        queries: {
          offset: 0,
          limit: 10,
          term: null,
          searchOnFields: null,
          dateFrom: null,
          dateUpTo: null,
          aggregates: [],
          orderBy: null,
          order: 'desc'
        }
      },
      showLmBreadcrumb: false,
      isContentPageLoading: true,
      isTableProcessing: true,
      isDataProcessing: true,
      titleList: '',
      subTitlesList: [],
      offset: 0,
      tableItemsTotal: 0,
      orderBy: null,
      order: 'desc',
      itemsPerPage: 10,
      showTable: true,
      showMap: false,
      showBox: false,
      map: {
        LMap: {
          props: {}
        },
        LPopup: {
          props: {}
        }
      },
      table: {
        fields: [],
        items: []
      },
      filter: {
        aggregatesToSelect: {},
        aggregatesSelected: [],
        totalResult: 0
      },
      pagination: {},
      searcher: {
        lmSuperPowerSelectsV2: [],
        searchOnFieldsToSelect: [],
        searchOnFieldsSelected: [],
        term: null,
        dateFrom: '',
        dateUpTo: '',
        maxDateUpTo: 'today',
        showFilterTime: false
      },
      buttons: {},
      form: {}
    }
  },
  props: {
    listBuilderId: {
      type: String,
      default: ''
    },
    isOnWidgetMode: {
      type: Boolean,
      default: false
    },
    isOnEditMode: {
      type: Boolean,
      default: false
    },
    listEndpointUri: {
      type: String,
      default: ''
    },
    isGraphql: {
      type: Boolean,
      default: false
    },
    gqlQuery: {
      type: String,
      default: ''
    },
    gqlField: {
      type: String,
      default: ''
    },
    gqlVariables: {
      type: Object,
      default: () => {}
    },
    searchOnFieldsSelected: {
      type: Array,
      default: () => []
    },
    searchOnFieldsToSelected: {
      type: Array,
      default: () => []
    },
    allAvailableFields: {
      type: Array,
      default: () => []
    },
    variablesToNotExpand: {
      type: Array,
      default: () => ['sort', 'page']
    },
    mode: {
      type: Object,
      default: () => ({
        table: true,
        map: false
      })
    },
    listBuilderTitleList: {
      type: String,
      default: ''
    },
    listBuilderButtons: {
      type: Array,
      default: () => []
    },
    modeBoxOptions: {
      type: [Object],
      default: () => ({})
    }
    // softPermissions: {
    //   type: Object,
    //   default: () => {}
    // }
  },
  computed: {
    showFilters () {
      return JSON.stringify(this.filter.aggregatesToSelect) !== '{}' || this.filter?.aggregatesSelected?.length
    },
    getToOfPagination () {
      if (this.$route.query.page && (this.itemsPerPage * this.$route.query.page) <= this.tableItemsTotal) {
        return this.itemsPerPage * this.$route.query.page
      } else if (this.$route.query.page && (this.itemsPerPage * this.$route.query.page) > this.tableItemsTotal) {
        return this.tableItemsTotal
      } else if (this.tableItemsTotal < this.itemsPerPage) {
        return this.tableItemsTotal
      } else {
        return this.itemsPerPage
      }
    },
    tableSortDesc () {
      return this.order === 'desc'
    },
    tableStriped () {
      return this.table.striped !== false
    },
    tableResponsive () {
      return this.table.responsive !== false
    },
    tableHover () {
      return this.table.hover !== false
    },
    paginationHideEllipsis () {
      return this.pagination.hideEllipsis !== false
    },
    paginationFirstText () {
      return this.pagination.firstText || this.$t('first')
    },
    paginationLastText () {
      return this.pagination.lastText || ''
    }
  },
  methods: {
    confirmModalOk (form) {
      this.form = form
    },
    isFieldVisibleOnScreen (fieldKey) {
      return this.table.fields.findIndex(el => el.key === fieldKey) > -1
    },
    hideShowColumns (checkStatus, fieldKey, allAvailableFieldsIndexField) {
      if (checkStatus) {
        const field = this.table.allAvailableFields.find(el => el.key === fieldKey)
        const noDeleteElement = 0
        const insertElementOnIndex = allAvailableFieldsIndexField
        this.table.fields.splice(insertElementOnIndex, noDeleteElement, field)
      } else {
        const deleteFieldOnIndex = this.table.fields.findIndex(el => el.key === fieldKey)
        if (deleteFieldOnIndex > -1) {
          const deleteOnelement = 1
          this.table.fields.splice(deleteFieldOnIndex, deleteOnelement)
        }
      }
    },
    createFilterMethod () {
      this.buttons.filterCreator.fullFrontEndUrl = window.location.href
      this.$refs.lmCreateFilterModal.lmShow()
    },
    createSegmentMethod () {
      this.buttons.segment.fullFrontEndUrl = window.location.href
      this.$refs.lmCreateSegmentModal.lmShow()
    },
    tableSortingChanged (event) {
      this.urlQueryBuilder({ orderBy: event.sortBy })
      this.urlQueryBuilder({ order: event.sortDesc === true ? 'desc' : 'asc' })
    },
    openEmailPreviewModal (idEmailTemplate) {
      this.$refs.lmTemplatePreviewModal.openEmailPreviewModal(idEmailTemplate)
    },
    variantBuilder (row, index) {
      return row?.split(',')[index] || 'info'
    },
    async openCustomModal (args = {}) {
      let {
        endpoint,
        title,
        message,
        successMessage,
        isComment,
        isCommentValidationRequired,
        labelComment,
        requestMethod,
        delayAfterSubmit
      } = args
      this.$refs.lmConfirmationModal.setMessageProps(message || 'Está seguro que desea realizar esta acción?')
      this.$refs.lmConfirmationModal.setTitleProps(title || 'Aviso')
      this.$refs.lmConfirmationModal.setIsCommentProps(isComment, isCommentValidationRequired, labelComment)
      //   this.$refs.lmConfirmationModal.title = title
      try {
        await this.$refs.lmConfirmationModal.lmShow()
        this.isDataProcessing = true
        // TODO: el tipo de request a realizar debe ser pasado como parametro y los unicos tipos de request
        // permitidos serán POST / PUT / DELETE.  El valor por defecto va a ser POST siempre, incluso si no se
        // especifica
        // Esto es en referencia a lo pedido en https://github.com/lumile/lumbre/issues/729#issuecomment-838668921
        // GET no debe ser utilizado.
        // Y en caso que el modal requiera un comentario el mismo debe enviarse siempre en el request usando como
        // nombre de argumento `comment`
        if (requestMethod === 'POST') {
          await commonsApi.axiosPostWrapper(endpoint, this.form)
        } else if (requestMethod === 'PUT') {
          await commonsApi.axiosPutWrapper(endpoint)
        } else if (requestMethod === 'DELETE') {
          await commonsApi.axiosDeleteWrapper(endpoint)
        } else {
          await commonsApi.axiosPostWrapper(endpoint, this.form)
        }

        // Si hay un delayAfterSubmit mayor a 0 se va a esperar a que finalize el delay para recargar el
        // listado.  Acción que se lleva a cabo indirectamente por la llamada a setDataPageAndComponentsProps()
        if (delayAfterSubmit > 0) {
          setTimeout(() => {
            this.setDataPageAndComponentsProps()
            this.isDataProcessing = false
          }, delayAfterSubmit)
        } else {
          this.setDataPageAndComponentsProps()
          this.isDataProcessing = false
        }
        if (successMessage) {
          this.lmToastSuccessMessage(successMessage, 'Operación realizada con éxito')
        }
      } catch (error) {
        const jsonError = JSON.stringify(error)
        const parseError = JSON.parse(jsonError)
        const errorMessage = parseError.response?.data?.message
        this.$bvToast.toast(errorMessage, {
          title: 'Error',
          toaster: 'b-toaster-bottom-center',
          variant: 'danger',
          solid: true
        })
      }
    },
    async openDeleteModal (id, endPointPath, message, successMessage) {
      this.$refs.lmConfirmationModal.setMessageProps(message || 'Está seguro que desea eliminar este registro?')
      try {
        await this.$refs.lmConfirmationModal.lmShow()
        this.isDataProcessing = true
        await commonsApi.axiosDeleteWrapper(process.env.VUE_APP_API_URL + endPointPath + id)
        this.setDataPageAndComponentsProps()
        if (successMessage) {
          this.lmToastSuccessMessage(successMessage, 'Registro Eliminado')
        }
      } catch (error) {
        const jsonError = JSON.stringify(error)
        const parseError = JSON.parse(jsonError)
        const errorMessage = parseError.response?.data?.message
        this.$bvToast.toast(errorMessage, {
          title: 'Error',
          toaster: 'b-toaster-bottom-center',
          variant: 'danger',
          solid: true
        })
      } finally {
        this.isDataProcessing = false
      }
    },
    linkGen (pageNum) {
      return {
        query: {
          ...this.$route.query,
          page: pageNum
        }
      }
    },
    queryApiUrlBuilder () {
      this.endpointUri = {
        path: this.listEndpointUri,
        queries: {
          offset: this.$route.query.page && this.$route.query.page > 1 ? (this.$route.query.page * this.itemsPerPage) - this.itemsPerPage : 0,
          limit: this.itemsPerPage,
          term: this.$route.query.term || null,
          searchOnFields: (() => {
            if (this.$route.query.searchOnFields) {
              return JSON.parse(this.$route.query.searchOnFields)
            } else {
              return this.searcher.searchOnFieldsToSelect.find(i => i.name) ? this.searcher.searchOnFieldsToSelect.map(i => i.name) : []
            }
          })(),
          dateFrom: this.$route.query.dateTimeFrom || null,
          dateUpTo: this.$route.query.dateTimeUpTo || null,
          aggregates: this.$route.query.aggregates ? JSON.parse(this.$route.query.aggregates) : [],
          orderBy: this.$route.query.orderBy || this.orderBy || null,
          order: this.$route.query.order || this.order || 'desc',
          superPowers: this.$route.query?.superPowers || {},
          polygons: this.$route.query.polygons || null,
          radius: this.$route.query.radius || null,
          lat: this.$route.query.lat || null,
          lng: this.$route.query.lng || null
        }
      }
      this.endpointUri.queryString = ''
      const notQueryIfFalsy = ['offset', 'term', 'dateUpTo', 'dateFrom', 'orderBy', 'aggregates', 'superPowers', 'polygons', 'radius', 'lat', 'lng']
      const query = this.endpointUri.queries
      notQueryIfFalsy.forEach(property => {
        if (query[property] === '{}') {
          delete query[property]
        }
        if (query[property] !== null && typeof query[property] === 'object' && Object.keys(query[property]).length === 0) {
          delete query[property]
        }
        if (Array.isArray(query[property]) && query[property].length === 0) {
          delete query[property]
        } else if (!query[property]) {
          delete query[property]
        }
      })
      Object.keys(query).forEach((key, index) => {
        if (key === 'aggregates' && query[key].length) {
          query[key].forEach((element) => {
            let key = Object.keys(element)
            this.endpointUri.queryString += `${this.endpointUri.queryString.includes('?') ? '&' : '?'}${key}=${element[key]}`
          })
        } else if (key === 'searchOnFields') {
          query[key].forEach(element => {
            this.endpointUri.queryString += `${this.endpointUri.queryString.includes('?') ? '&' : '?'}search_on_fields=${element}`
          })
        } else if (key === 'orderBy') {
          this.endpointUri.queryString += `${this.endpointUri.queryString.includes('?') ? '&' : '?'}order_by=${query[key]}`
        } else if (key === 'dateFrom') {
          this.endpointUri.queryString += `${this.endpointUri.queryString.includes('?') ? '&' : '?'}date_from=${query[key]}`
        } else if (key === 'dateUpTo') {
          this.endpointUri.queryString += `${this.endpointUri.queryString.includes('?') ? '&' : '?'}date_up_to=${query[key]}`
        } else if (key === 'polygons') {
          this.endpointUri.queryString += `${this.endpointUri.queryString.includes('?') ? '&' : '?'}polygons=${query[key]}`
        } else if (key === 'radius') {
          this.endpointUri.queryString += `${this.endpointUri.queryString.includes('?') ? '&' : '?'}radius=${query[key]}`
        } else if (key === 'lat') {
          this.endpointUri.queryString += `${this.endpointUri.queryString.includes('?') ? '&' : '?'}lat=${query[key]}`
        } else if (key === 'lng') {
          this.endpointUri.queryString += `${this.endpointUri.queryString.includes('?') ? '&' : '?'}lng=${query[key]}`
        } else {
          this.endpointUri.queryString += `${this.endpointUri.queryString.includes('?') ? '&' : '?'}${key}=${encodeURIComponent(query[key])}`
        }
      })
    },
    async processingGraphqlQuery () {
      try {
        this.isDataProcessing = true
        this.page = this.$route.query.page || this.gqlVariables.page
        this.page = this.page ? this.page : 1
        let q = this.$route.query.term ? this.$route.query.term : this.gqlVariables.q
        const orderBy = this.$route.query.orderBy
        const order = this.$route.query.order
        const sort = orderBy ? orderBy + '__' + order : this.gqlVariables.sort
        let searchOnFields = this.$route.query.searchOnFields
        let aggregates = this.$route.query.aggregates ? JSON.parse(this.$route.query.aggregates) : null
        var queryAggregates = null
        let aggs = aggregates ? [] : this.gqlVariables.aggs

        this.showTable = this.mode.table
        this.showMap = this.mode.map
        this.showBox = this.mode.box

        if (aggregates) {
          let beforeText = null
          let beforeKey = null
          _.forEach(aggregates, function (value, key) {
            _.mapKeys(aggregates[key], function (value, key) {
              if (key === 'field') {
                queryAggregates = queryAggregates
                  ? queryAggregates + ' AND ' + value + ':"' + beforeText + '"'
                  : value + ':"' + beforeText + '"'
                aggs.push({
                  key: beforeKey,
                  value: {
                    terms: {
                      field: value
                    }
                  }
                })
              }
              beforeKey = key
              beforeText = value
            })
          })
        }

        if (this.$route.query.aggregates) {
          aggs = _.differenceWith(this.gqlVariables.aggs, aggs, _.isEqual)
        }

        if (searchOnFields) {
          const isActiveCustomSearchInFields = q.substring(0, 3) === 'csf '
          if (isActiveCustomSearchInFields) {
            q = q.slice(4, 1000)
          } else {
            searchOnFields = JSON.parse(this.$route.query.searchOnFields)
            if (!this.$route.query.term) {
              q = '*'
            }
            searchOnFields = searchOnFields.join(':' + q + ' OR ')
            if (this.gqlVariables.q) {
              q = '(' + searchOnFields + ':' + q + ')'
              if (this.gqlVariables.q !== '*') {
                q = '(' + searchOnFields + ':' + q + ') AND (' + this.gqlVariables.q + ')'
              }
              if (aggregates) {
                q = q + ' AND (' + queryAggregates + ')'
              }
            } else {
              q = searchOnFields + ':' + q
            }
          }
        } else {
          if (aggregates) {
            q = q + ' AND (' + queryAggregates + ')'
          }
        }

        // Esta logica permite expandir variables que vengan definidas en variablesGraphql
        // usando _.template.
        // Esto permite expandir strings `'/obras/pase/copiadeplano/${route.params.id}'`
        const newVariablesGraphql = Object.assign({}, this.gqlVariables)
        newVariablesGraphql.q = q
        for (const key of Object.keys(newVariablesGraphql).filter(i => !this.variablesToNotExpand.includes(i))) {
          const templateToCompile = _.template(newVariablesGraphql[key])
          const expanded = templateToCompile({ 'route': this.$route })
          newVariablesGraphql[key] = expanded
        }
        newVariablesGraphql.page = parseInt(this.page)
        newVariablesGraphql.sort = sort
        newVariablesGraphql.aggs = aggs

        this.apolloQuery = await this.$apollo.query({ query: gql`${this.gqlQuery}`, variables: newVariablesGraphql })
        if (this.apolloQuery.data[this.gqlField] === null) {
          throw new Error('Elastic Index Not Found')
        }
        this.titleList = this.apolloQuery.data[this.gqlField]?.titleList
        this.subTitlesList = this.apolloQuery.data[this.gqlField]?.subTitlesList || []
        this.table = this.apolloQuery.data[this.gqlField]?.table
        this.tableItemsTotal = this.apolloQuery.data[this.gqlField]?.tableItemsTotal
        this.itemsPerPage = this.apolloQuery.data[this.gqlField]?.itemsPerPage || 10
        this.buttons = this.apolloQuery.data[this.gqlField]?.buttons || {}

        if (Array.isArray(this.buttons?.links)) {
          for (const button of this.buttons.links) {
            if (button?.endpointToValidateVisibility) {
              try {
                const res = await commonsApi.axiosGetWrapper(button.endpointToValidateVisibility)
                if (!res?.data?.status) {
                  button.disabled = true
                }
              } catch (error) {
                button.disabled = true
              }
            }
          }
        }
        if (this.apolloQuery.data[this.gqlField]?.pagination) {
          this.pagination = 'pagination' in this.apolloQuery.data[this.gqlField] ? this.apolloQuery.data[this.gqlField]?.pagination : {}
        }
        // this.showTable = 'showTable' in this.apolloQuery.data[this.gqlField] ? this.apolloQuery.data[this.gqlField].showTable : true
        // this.showMap = 'showMap' in this.apolloQuery.data[this.gqlField] ? this.apolloQuery.data[this.gqlField].showMap : false
        if (this.apolloQuery.data[this.gqlField]?.map) {
          this.map = this.apolloQuery.data[this.gqlField].map
        }

        this.filter.aggregatesToSelect = this.apolloQuery.data[this.gqlField]?.filter?.aggregatesToSelect || {}
        this.filter.totalResult = this.apolloQuery.data[this.gqlField]?.filter?.totalResult || 0
        this.filter.aggregatesSelected = this.$route.query.aggregates ? JSON.parse(this.$route.query.aggregates) : []

        this.searcher.term = this.apolloQuery.data[this.gqlField]?.searcher?.term || this.$route.query.term || null
        this.searcher.searchOnFieldsToSelect = this.apolloQuery.data[this.gqlField]?.searcher?.searchOnFieldsToSelect?.length ? this.apolloQuery.data[this.gqlField].searcher?.searchOnFieldsToSelect : []
        if (Array.isArray(this.apolloQuery.data[this.gqlField]?.searcher?.searchOnFieldsToSelect)) {
          this.searcher.searchOnFieldsSelected = this.$route.query.searchOnFields ? JSON.parse(this.$route.query.searchOnFields) : this.apolloQuery.data[this.gqlField].searcher?.searchOnFieldsToSelect.map(i => i.name)
        }
        this.searcher.dateFrom = this.apolloQuery.data[this.gqlField]?.searcher?.dateTimeFrom || this.$route.query.dateTimeFrom || null
        this.searcher.dateUpTo = this.apolloQuery.data[this.gqlField]?.searcher?.dateTimeUpTo || this.$route.query.dateTimeUpTo || null
        this.searcher.maxDateUpTo = this.apolloQuery.data[this.gqlField]?.searcher?.maxDateUpTo || 'today'
        this.searcher.showFilterTime = this.apolloQuery.data[this.gqlField]?.searcher?.showFilterTime || false
        this.searcher.lmSuperPowerSelectsV2 = this.apolloQuery.data[this.gqlField]?.searcher?.lmSuperPowerSelectsV2 || []

        this.orderBy = this.$route.query.orderBy || this.apolloQuery.data[this.gqlField]?.initialOrderBy || null
        this.order = this.$route.query.order || this.apolloQuery.data[this.gqlField]?.order || 'desc'
        this.showLmBreadcrumb = process.env.VUE_APP_SHOWBREADCRUMB === 'yes' ? this.apolloQuery.data[this.gqlField].showLmBreadcrumb : false

        // if (this.isOnEditMode) {
        //   if (JSON.stringify(this.$parent.form.newFields) === '[]') {
        //     this.table.allAvailableFields = this?.allAvailableFields ? this?.allAvailableFields : []
        //   } else {
        //     this.table.allAvailableFields = this.$parent.form.newFields ? this.$parent.form.newFields : []
        //   }
        // } else {
        //   this.table.allAvailableFields = await this?.allAvailableFields ? this?.allAvailableFields : []
        // }

        if (this.isOnEditMode) {
          if (this.allAvailableFields.length !== 0) {
            this.table.allAvailableFields = JSON.stringify(this.$parent?.form?.newFields) === '[]' ? this.allAvailableFields : []
            this.table.allAvailableFields = JSON.stringify(this.$parent?.form?.newFields) !== '[]' ? this.$parent?.form?.newFields : []
          }
        } else {
          this.table.allAvailableFields = this?.allAvailableFields ? this?.allAvailableFields : []
        }
        if (this.table?.allAvailableFields) {
          this.table.fields = this.table?.allAvailableFields.length === 0 ? this.table?.fields : this.table?.allAvailableFields
        }
      } catch (error) {
        this.titleList = this.listBuilderTitleList
        this.buttons = {
          links: this.listBuilderButtons
        }
        this.searcher.searchOnFieldsToSelect = this.searchOnFieldsToSelected
        this.searcher.searchOnFieldsSelected = this.searchOnFieldsToSelected
      } finally {
        this.isContentPageLoading = false
        this.isDataProcessing = false
        this.isTableProcessing = false
      }
    },
    async initialSetting () {
      if (this.isGraphql) {
        // @pekastel: Comento esta llamada porque es innecesaria.
        // this.processingGraphqlQuery()
      } else {
        try {
          this.isContentPageLoading = true
          this.orderBy = null
          const endPoint = await commonsApi.axiosGetWrapper(this.listEndpointUri)
          this.order = endPoint.data.order
          this.orderBy = endPoint.data.initialOrderBy
          this.itemsPerPage = endPoint.data.itemsPerPage
          this.queryApiUrlBuilder()
        } catch (error) {
          console.log('error', error)
        } finally {
          this.isContentPageLoading = false
        }
      }
    },
    async setDataPageAndComponentsProps () {
      if (this.isGraphql) {
        this.processingGraphqlQuery()
      } else {
        try {
          this.isDataProcessing = true
          this.queryApiUrlBuilder()

          const endPointResponse = await commonsApi.axiosGetWrapper(this.endpointUri.path + this.endpointUri.queryString)
          const endPointResponseData = endPointResponse.data
          this.titleList = endPointResponseData.titleList
          this.subTitlesList = endPointResponseData.subTitlesList
          this.table = endPointResponseData.table
          this.tableItemsTotal = endPointResponseData.tableItemsTotal || 0
          this.itemsPerPage = endPointResponseData.itemsPerPage || 10
          this.buttons = endPointResponseData.buttons || {}

          this.pagination = 'pagination' in endPointResponseData ? endPointResponseData.pagination : {}

          this.showTable = 'showTable' in endPointResponseData ? endPointResponseData.showTable : true
          this.showMap = 'showMap' in endPointResponseData ? endPointResponseData.showMap : false
          this.map = endPointResponseData.map

          this.filter.aggregatesToSelect = endPointResponseData.filter?.aggregatesToSelect || {}
          this.filter.totalResult = endPointResponseData.filter?.totalResult || 0
          this.filter.aggregatesSelected = this.$route.query.aggregates ? JSON.parse(this.$route.query.aggregates) : []

          this.searcher.term = endPointResponseData.searcher?.term || this.$route.query.term || null
          this.searcher.searchOnFieldsToSelect = endPointResponseData.searcher?.searchOnFieldsToSelect?.length ? endPointResponseData.searcher?.searchOnFieldsToSelect : []
          if (Array.isArray(endPointResponseData.searcher?.searchOnFieldsToSelect)) {
            this.searcher.searchOnFieldsSelected = this.$route.query.searchOnFields ? JSON.parse(this.$route.query.searchOnFields) : endPointResponseData.searcher?.searchOnFieldsToSelect.map(i => i.name)
          }
          this.searcher.dateFrom = endPointResponseData.searcher?.dateTimeFrom || this.$route.query.dateTimeFrom || null
          this.searcher.dateUpTo = endPointResponseData.searcher?.dateTimeUpTo || this.$route.query.dateTimeUpTo || null
          this.searcher.maxDateUpTo = endPointResponseData.searcher?.maxDateUpTo || 'today'
          this.searcher.showFilterTime = endPointResponseData.searcher?.showFilterTime || false
          this.searcher.lmSuperPowerSelectsV2 = endPointResponseData.searcher?.lmSuperPowerSelectsV2 || []

          this.orderBy = this.$route.query.orderBy || endPointResponseData.initialOrderBy || null
          this.order = this.$route.query.order || endPointResponseData.order || 'desc'
          this.showLmBreadcrumb = process.env.VUE_APP_SHOWBREADCRUMB === 'yes' ? endPointResponseData.showLmBreadcrumb : false

          this.isTableProcessing = false
        } catch (error) {
          console.log('error', error)
        } finally {
          this.isDataProcessing = false
        }
      }
    },
    whenTableChange () {
      this.$parent.form.fields = this.table?.fields
    }
  },
  watch: {
    async '$route.path' () {
      if (this.showFilters && this.$refs.lmFilter !== undefined) {
        this.$refs.lmFilter.hide()
      }
      this.$refs.lmSearcher.closeMoreOptions()
      await this.initialSetting()
      await this.setDataPageAndComponentsProps()
    },
    async '$route' (val, oldVal) {
      if (val.path === oldVal.path && JSON.stringify(val.query) !== JSON.stringify(oldVal.query)) {
        await this.setDataPageAndComponentsProps()
      }
    },
    gqlVariables (newVal, oldVal) {
      this.initialSetting()
    },
    gqlField (newVal, oldVal) {
      this.initialSetting()
    },
    mode (newVal, oldVal) {
      this.initialSetting()
    },
    listBuilderTitleList (newVal, oldVal) {
      this.titleList = newVal
    },
    table: {
      deep: true,
      handler: function (newVal, oldVal) {
        if (this.isOnEditMode) this.whenTableChange()
      }
    }
  },
  directives: {
    dragTableHeader: {
      inserted: (el, binding) => {
        const tableHeader = el.querySelector('table thead #dragable-column')
        // eslint-disable-next-line no-new
        if (tableHeader) {
          // eslint-disable-next-line no-new
          new Sortable(tableHeader, {
            animation: 150,
            ghostClass: 'blue-background-class',
            onEnd: (event) => {
              const fieldToMove = binding.value.find((field, index) => index === event.oldIndex)
              const deleteOnelement = 1
              const deleteElementOnIndex = event.oldIndex
              binding.value.splice(deleteElementOnIndex, deleteOnelement)
              const noDeleteElement = 0
              const insertElementOnIndex = event.newIndex
              binding.value.splice(insertElementOnIndex, noDeleteElement, fieldToMove)
            }
          })
        }
      }
    }
  },
  async created () {
    await this.initialSetting()
    await this.setDataPageAndComponentsProps()
    // Si NO estamos dentro de LmListBuilder
    // if (this.softPermissions) {
    //   // Check user permissions
    //   this.userPrivileges = checkSoftPermissions(this.softPermissions)
    //   console.log(this.userPrivileges)
    //   if (!this.userPrivileges.allowAccess) {
    //     this.$router.push('/')
    //   }
    // }
  },
  async mounted () {
    if (this.isGraphql) {
      try {
        if (this.gqlQuery) {
          this.apolloQuery = await this.$apollo.query({ query: gql`${this.gqlQuery}`, variables: this.gqlVariables })
        }
      } catch (e) {
        console.log('gqlSchema:', this.gqlQuery)
        console.log('gqlVaribles:', JSON.stringify(this.gqlVariables))
        console.log('graphQlAllErrors:', JSON.stringify(e))
        console.log('graphQlNetworkError:', JSON.stringify(e.networkError))
        console.log('graphQlErrors:', JSON.stringify(e.graphQLErrors))

        this.isContentPageLoading = false
        this.isDataProcessing = false
        this.isTableProcessing = false
      }
    }
  }
}
</script>

<style lang="sass" scoped>
table
  thead
    #dragable-column
      &.table-is-on-edit
        th
          &:hover
            cursor: move
    .menu-hide-show-columns
      column-count: 2
.lm-table-while-loading
  height: 300px
.no-search-found
  padding: 5%
  flex-grow: 1
  img
    margin: 0 auto 30px auto
    display: block
    @media(max-width: $md)
      max-width: 50%
  h1,
  h2
    color: $primaryFontThemeColor
    max-width: 700px
    margin: 0 auto
    text-align: center
    @media(max-width: $md)
      min-width: 100px
  h1
    font-size: 24px
    margin-bottom: 10px
    @media(max-width: $md)
      font-size: 18px
  h2
    font-size: 18px
    @media(max-width: $md)
      font-size: 14px
.btable
  overflow-x: auto
  width: 100%;
  display: grid
  // white-space: nowrap
  @media(max-width: $xl)
    width: 100%
</style>
